import { getAuth } from 'firebase/auth';
import { doc } from 'firebase/firestore';
import { collection, CollectionReference } from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirebaseApp } from './useFirebaseApp';
import { useFirestore } from './useFirestore';

export const IN_CLAUSE_LIMIT = 10;

export const useCurrentUserGuid = (): string => {
  const firebase = useFirebaseApp();
  const userGuid = getAuth(firebase).currentUser?.uid;
  if (!userGuid) {
    throw 'Firebase is not authenticated';
  }
  return userGuid;
};

export const useCurrentFirebaseUserRef = () => {
  const userCollection = useUserCollection();
  const currentUserGuid = useCurrentUserGuid();
  return useMemo(
    () => doc(userCollection, currentUserGuid),
    [userCollection, currentUserGuid],
  );
};

const useCollection = (name: string): CollectionReference => {
  const firestore = useFirestore();
  return useMemo(() => collection(firestore, name), [name, firestore]);
};

export const useUserCollection = (): CollectionReference => {
  return useCollection('brightlink_users');
};

export const useChannelCollection = (): CollectionReference => {
  return useCollection('brightlink_channels');
};

export const useMessageCollection = (
  channelGuid: string,
): CollectionReference => {
  return useCollection(`brightlink_channels/${channelGuid}/messages`);
};

export const useChannelDoc = (chanelGuid: string) => {
  const channelCollection = useChannelCollection();
  return useMemo(
    () => doc(channelCollection, chanelGuid),
    [chanelGuid, channelCollection],
  );
};
